import React from "react";
import Slider from "@mui/material/Slider";
import { Box } from "@mui/material";

interface SliderComponentProps {
  label: string;
  value: number;
  onChange: (event: Event, newValue: number | number[]) => void;
  marks: { value: number; label: string }[];
  min: number;
  max: number;
}

// Function to determine the track color based on the slider value
const getTrackColor = (value: number) => {
  if (value <= 4) {
    return "#E3151A"; // Red for 1 to 4
  } else if (value <= 7) {
    return "#EF9200"; // Orange for 4 to 7
  } else {
    return "#2B9241"; // Green for 7 to 10
  }
};

const SliderComponent: React.FC<SliderComponentProps> = ({
  label,
  value,
  onChange,
  marks,
  min,
  max,
}) => {
  return (
    <Box>
      {/* <p>{label}</p> */}
      <Slider
        aria-label={label}
        value={value}
        onChange={onChange}
        valueLabelDisplay="auto"
        step={1}
        marks={marks}
        min={min}
        max={max}
        sx={{
          // Dynamically change the color of the track
          "& .MuiSlider-track": {
            backgroundColor: getTrackColor(value), // Change color based on value
            height: 8,
            borderRadius: 5,
          },
          "& .MuiSlider-thumb": {
            height: 20,
            width: 20,
            backgroundColor: getTrackColor(value),
            borderRadius: "50%",
          },
          "& .MuiSlider-rail": {
            backgroundColor: "#F1F1F1",
            height: 8,
          },
          "& .MuiSlider-valueLabel": {
            color: "white",
            backgroundColor: getTrackColor(value),
            borderRadius: 10,
          },
        }}
      />
    </Box>
  );
};

export default SliderComponent;
